<template>
  <div class="label-row" :class="[types == 'trader' ? 'line-color-trader' : 'line-color-spot' ]">
    <div class="label-left">
      <h3>
        {{ formatTitle }}
        <i class="fa fa-info-circle" v-tooltip="arrFormula"></i>
      </h3>
      <p>{{ formatSubTitle }}</p>
    </div>
    <div class="label-right">
      <div class="label-price" :class="priceChangeColor">{{formatPrice}}</div>
      <p>{{ formatUnit }}</p>
    </div>
  </div>
</template>
<script>
import { VTooltip } from "v-tooltip"
import { formatCurrency } from "../../../utils/global"
export default {
  directives: {
    tooltip: VTooltip
  },
  props: {
    types: {
      type: String,
      default: "trader"
    },
    objData: {
      type: Object,
      default() {
        return {}
      }
    },
    price: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      priceChangeColor: null,
      arrFormula: {
        placement: "auto",
        offset: 5,
        content: `คือ ราคาทองคำโลกที่ได้นำมาคำนวนสูตร <br/><span class="gold-formula-text"> XAUUSD (ราคาทองคำต่างประเทศ / Oz) x THB(ค่าเงินบาท) x (0.49) x 0.965 </span><br/>เพื่อแปลงออกมาเป็นราคาทองคำหน่วยบาท / บาทน้ำหนักทองคำ`
      }
    }
  },
  watch: {
    price(val, oldVal) {
      val > oldVal ? (this.priceChangeColor = "plus") : (this.priceChangeColor = "minus")
      setTimeout(() => {
        this.priceChangeColor = "normal"
      }, 500)
    }
  },
  computed: {
    formatTitle() {
      switch (this.types) {
        case "spot":
          return `ราคาทองคำโลก`
        default:
          return `ราคา Real-time`
      }
    },
    formatSubTitle() {
      switch (this.types) {
        case "spot":
          return `ทองคำแท่ง 99.9%`
        default:
          return `ทองคำแท่ง 96.5%`
      }
    },
    formatPrice() {
      switch (this.types) {
        case "spot":
          return formatCurrency(this.price, 'USD', 3)
        default:
          return formatCurrency(this.price, 'THB', 2)
      }
    },
    formatUnit() {
      switch (this.types) {
        case "spot":
          return `/Oz`
        default:
          return `/บาททอง`
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.label-row {
  position: relative;
  padding: 8px 14px;
  min-height: 40px;
  margin: 4px 0;
  border: solid 1px #f9f9f9;
  background-color: $color-white;
  .label-left {
    @include finCol(6, 12, 0px, middle, true, true);
    h3 {
      @extend %font-size-s;
      font-weight: bold;
      color: $color-normal-text;
      i {
        color: #d1d1d1;
      }
    }
    p {
      margin: 0;
      @extend %font-size-ss;
      color: $color-normal-text;
    }
  }
  .label-right {
    @include finCol(6, 12, 0px, middle, true, true);
    text-align: right;
    .label-price {
      @extend %font-size-l;
      font-weight: bold;
      color: $color-normal-text;
    }
    p {
      margin: 0;
      @extend %font-size-ss;
      color: $color-normal-text;
    }
  }
  &:before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 6px;
  }
}
.line-color-trader {
  &:before {
    background-color: $color-orange;
  }
}
.line-color-spot {
  &:before {
    background-color: #3fc0bf;
  }
}
</style>